<template>
  <div class="bottomchat">
    <div class="container">
      <!-- Here are the suggestions -->
      <div class="suggestions">
          <Suggestion v-if="suggestions.text_suggestions"
            v-for="(suggestion, index) in suggestions.text_suggestions"
            :key="index+'_text_suggestion'"
            @click.native="$emit('submit', suggestion, 'suggestion')"
            :title="suggestion"
          />
        <Suggestion
          v-if="suggestions.link_suggestion"
          v-for="(suggestion, index) in suggestions.link_suggestion"
            :key="index+'_link_suggestion'"
            :title="suggestion.destinationName"
            :url="suggestion.uri"
        />
        <Suggestion
          v-if="suggestions.postback_suggestion"
            v-for="(suggestion, index) in suggestions.postback_suggestion"
            :key="index+'_postback_suggestion'"
            :title="suggestion.title"
            @click.native="$emit('submit_postback', suggestion.title, suggestion.postback, 'suggestion')"
        />
      </div>
      <div class="flexible">
        <!-- Text input -->
        <div class="input-container">
          <input
            :aria-label="(config.i18n[lang()] && config.i18n[lang()].inputTitle) || config.i18n[config.app.fallback_lang].inputTitle"
            :class="this.disabled === true ? 'inputDisabled' : 'input'"
            type="text"
            :placeholder="(config.i18n[lang()] && config.i18n[lang()].inputTitle) || config.i18n[config.app.fallback_lang].inputTitle"
            v-model="query"
            @keypress.enter="submit()"
            autofocus
          >
        </div>

        <label
          for="attachmentInput"
          id="file-drag"
          class="button-container"
          v-bind:class=" { disabled: !canSendImage } "
        >
          <i class="material-icons" aria-hidden="true">attachment</i>
        </label>
        <input
          type="file"
          name="file"
          id="attachmentInput"
          accept="image/png, image/gif, image/jpeg"

          hidden
          @change="sendImage($event, sendImagePayload)"
        >

        <!-- Send message button (arrow button) -->
        <div
          v-bind:class=" { disabled: query.length == 0 || disableMessages } "
          :aria-label="(config.i18n[lang()] && config.i18n[lang()].sendTitle) || config.i18n[config.app.fallback_lang].sendTitle"
          :title="(config.i18n[lang()] && config.i18n[lang()].sendTitle) || config.i18n[config.app.fallback_lang].sendTitle"
          class="button-container"
          @click="submit()"
        >
          <i class="material-icons" aria-hidden="true">send</i>
        </div>

        <!-- Microphone Button -->
        <!-- <div :aria-label="(config.i18n[lang()] && config.i18n[lang()].microphoneTitle) || config.i18n[config.app.fallback_lang].microphoneTitle" :title="(config.i18n[lang()] && config.i18n[lang()].microphoneTitle) || config.i18n[config.app.fallback_lang].microphoneTitle" class="button-container mic_button" :class="{'mic_active': micro}" @click="micro = !micro" v-else>
                    <i class="material-icons" aria-hidden="true">mic</i>
        </div>-->
      </div>
    </div>
  </div>
</template>

<style lang="sass" scoped>
@media only screen and (min-width: 601px)
  .bottomchat
    padding: 16px
    background-color: white
  .flexible
    display: flex
  .input-container
    width: 100%
    padding: 8px
    box-sizing: border-box
    border-radius: 40px
    flex: 1 0 0
    background-color: #F1F3F4
  .input
    font-size: 16px
    font-weight: 500
    width: 100%
    box-sizing: border-box
    background-color: transparent
    border: none
    outline: none
    padding-left: 8px
    padding-right: 8px
    color: #202124

  .inputDisabled
    font-size: 16px
    font-weight: 500
    width: 100%
    box-sizing: border-box
    background-color: transparent
    border: none
    outline: none
    padding-left: 8px
    padding-right: 8px
    color: #202124
    display: none

  .button-container
    padding: 8px
    width: 24px
    display: none
    height: 24px
    display: block;
    margin-left: 6px
    border-radius: 50%
    cursor: pointer
    background-color: #273795;
    color: white
    transition: background-color 100ms ease-out
    &.mic_button
      background-color: #F1F3F4
      color: #202124
      font-size: 24px
      &.mic_active
        background-color: #F44336
        color: white
  .button-container.disabled
    background-color: #F1F3F4
    pointer-events: none
    cursor: unset
@media only screen and (max-width: 600px)
  .bottomchat
    padding: 6px
    background-color: white
  .flexible
    display: flex
  .suggestions
    display: flex
    overflow-x: auto
  .suggestions > a
    white-space: nowrap
  .input-container
    height: 30px
    width: 100%
    padding: 6px 4px 4px 4px
    box-sizing: border-box
    border-radius: 40px
    flex: 1 0 0
    background-color: #F1F3F4
  .input
    font-size: 14px
    font-weight: 500
    width: 100%
    box-sizing: border-box
    background-color: transparent
    border: none
    outline: none
    padding-left: 8px
    padding-right: 8px
    color: #202124
  .button-container
    padding: 8px
    width: 16px
    height: 16px
    margin-left: 6px
    border-radius: 50%
    cursor: pointer
    background-color: rgb(64, 173, 156)
    color: white
    font-size: 4px
    transition: background-color 100ms ease-out
    &.mic_button
      background-color: #F1F3F4
      color: #202124
      font-size: 24px
      &.mic_active
        background-color: #F44336
        color: white
  .button-container.disabled
    background-color: #F1F3F4
    pointer-events: none
    cursor: unset
</style>

<script>
import Suggestion from "./../RichComponents/Suggestion.vue";

export default {
  name: "ChatInput",
  props: ["suggestions", "checkCanSendImage", "disabled"],
  components: {
    Suggestion
  },
  data() {
    return {
      query: "",
      micro: false,
      recognition: null,
      canSendImage: false,
      disableMessages: false,
      sendImagePayload: ''
    };
  },
  created() {
    if (window.webkitSpeechRecognition || window.SpeechRecognition) {
      this.recognition =
        new webkitSpeechRecognition() || new SpeechRecognition();
      this.recognition.interimResults = true;
      this.recognition.lang = this.lang();
    }
  },
  watch: {
    /* This function triggers when user clicks on the microphone button */
    micro(bool) {
      if (bool) {
        /* When value is true, start voice recognition */
        this.recognition.start();
        this.recognition.onresult = event => {
          for (let i = event.resultIndex; i < event.results.length; ++i) {
            this.query = event.results[i][0].transcript; // <- push results to the Text input
          }
        };

        this.recognition.onend = () => {
          this.recognition.stop();
          this.micro = false;
          this.submit(this.query); // <- submit the result
        };
      } else {
        this.recognition.abort(); // <- if user stops the recognition, abort it (in V1 this prevented users from starting a new recording)
      }
    },
    checkCanSendImage : function(newVal, _oldVal) {
      if(Object.keys(newVal).length !== 0) {
        this.canSendImage = true;
        this.disableMessages = newVal.disable_messages;
        this.sendImagePayload = newVal.payload;
      }else{
        this.canSendImage = false;
        this.disableMessages = false;
        this.sendImagePayload = '';
      }
    }
  },
  methods: {
    submit() {
      if (this.query.length > 0 && !this.disableMessages) {
        this.$emit("submit", this.query);
        this.query = "";
      }
    },
    sendImage(attachment, payload) {
      if(attachment.target.files.length > 0) {
        this.$emit("sendImage", attachment.target.files[0], payload);
        this.canSendImage = false;
        this.disableMessages = false;
        this.sendImagePayload = '';

        let list = new DataTransfer();
        document.getElementById('attachmentInput').files = list.files;
      }
    },
    sendButtonMessage(message, postback){
      const menu = document.getElementById("persistent-menu");
      if(menu.style.display == 'block'){
        this.$emit("submit_postback", message, postback);
        menu.style.display = 'none';
      }
    }
  }
};
</script>